import { HttpClient, httpResource } from '@angular/common/http';
import { Injectable, computed, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import type { CreateFlagDefinition, FlagDefinition, UpdateFlagDefinition } from '@zag/feature-flags/common';

@Injectable({ providedIn: 'root' })
export class FlagDefinitionsService {
  private readonly http = inject(HttpClient);
  private readonly basePath = '/api/v1/feature-flags/definitions';

  private readonly refreshTrigger = signal(0);

  private readonly listResource = httpResource<FlagDefinition[]>(() => {
    this.refreshTrigger();
    return this.basePath;
  });

  readonly definitions = computed(() => this.listResource.value() ?? []);
  readonly isLoading = computed(() => this.listResource.isLoading());
  readonly error = computed(() => this.listResource.error());

  reload(): void {
    this.refreshTrigger.update(v => v + 1);
  }

  create(payload: CreateFlagDefinition): Observable<FlagDefinition> {
    return this.http.post<FlagDefinition>(this.basePath, payload).pipe(tap(() => this.reload()));
  }

  update(key: string, payload: UpdateFlagDefinition): Observable<FlagDefinition> {
    return this.http.patch<FlagDefinition>(`${this.basePath}/${key}`, payload).pipe(tap(() => this.reload()));
  }
}
